// extracted by mini-css-extract-plugin
export default {"container":"co-z","ratingLayout":"do-z","ratingLabel":"eo-z","nonInteractiveRatingLabel":"fo-z"};